module.exports = __webpack_public_path__ + "img/Robert.945cac33.jpg";